import React from "react";
import zoomSdk from "@zoom/appssdk";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Modal, { ModalFooter } from "@amzn/meridian/esm/components/modal";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import Divider from "@amzn/meridian/esm/components/divider";
import Link from "@amzn/meridian/esm/components/link";

import aimsTheme from "../../meridian-theme-aims.json";
import LogManager from "../utils/LogManager";

const AMAZON_LEGAL_POLICY_URL = "https://w.amazon.com/bin/view/FPDS/Workplace_Trust/Privacy_Reviews/Workplace_trust_AI_review/Blueprints/ApprovedRecordingTools/";
const AIMS_POLICY_URL = "https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS/"


const InformSummarizeModal = ({ isOpen, onClose, onConfirm }) => {
  const handleOK = () => {
    console.log("User confirmed summarization in modal.");
    LogManager.info("User confirmed summarization in modal.");
    onConfirm();
  };

  //TODO: Add a util file to openURL
  const openUrl = async (url) => {
    console.log("trying to open url", url);
    try {
      await zoomSdk.openUrl({ url: url });
    } catch (error) {
      LogManager.error("Failed to open URL in Zoom:", error);
    }
  };

  return (
    <Theme
      palette={aimsTheme}
      tokens={{
        modalHeaderBackgroundColor: "rgba(124, 209, 187, 0.6)",
        modalHeaderSpacingInsetTop: "0px",
        modalHeaderSpacingInsetBottom: "0px",
        modalHeaderFontSize: "8px",
        modalHeaderMinHeight: "8px",
        modalFooterBorderColor: "#FFFFFF",
      }}
    >
      <Modal
        open={isOpen}
        onClose={onClose}
        closeLabel={null}
        shouldCloseOnOverlayClick={false}
        aria-describedby="modal-description"
        fullscreenBreakpoint="0"
        title=" "
        bodySpacingInset="400"
        scrollContainer="viewport"
      >
        <Column spacing="none" height="62vh">
          <Column spacing="none">
            <Theme tokens={{ textListSpacingVertical: "0px" }}>
              <Text fontFamily="amazonEmber" type="h200" alignment="start">
                Inform attendees about summarizing meetings
              </Text>
            </Theme>
          </Column>
          <Column height="18px" />
          <Column spacing="200">
            {/*<Text fontFamily="amazonEmber" type="h50">*/}
            {/*  <span>Don’t turn on meeting summary if</span>*/}
            {/*</Text>*/}
            <Text fontFamily="amazonEmber" type="b100">
              <ul>
                <li>
                  Do not use AiMS to summarize meetings if (a) prohibited by{" "}
                  <Link
                    type="primary"
                    onClick={() => openUrl(AMAZON_LEGAL_POLICY_URL)}
                    style={{ color: "#008060" }}
                  >
                    Amazon’s Recording, Transcription, and Summarization Policy
                  </Link>
                  , (b) with external participants, or (c) with attorney-client privileged communications.
                </li>
                <li>
                  Notify internal participants that the meeting will be summarized with AI. If an Amazon participant does not want to be summarized,
                  discuss and determine if summarizing the meeting is necessary based on a business need. Summarizations that are necessary may
                  proceed. As the meeting owner, you are responsible for using AiMS respectfully and in alignment with Amazon policy. See detailed
                  guidance{" "}
                  <Link
                    type="primary"
                    onClick={() => openUrl(AIMS_POLICY_URL)}
                    style={{ color: "#008060"}}
                  >
                    here
                  </Link>
                  .
                </li>
              </ul>
            </Text>
          </Column>
          <Column height="24px" spacing="none"></Column>
          <Column>
            <Divider spacingBefore="0" spacingAfter="0"></Divider>
          </Column>
          <Column height="24px" spacing="none"></Column>
          <Column spacing="none">
            <Theme tokens={{ textColorPrimary: "#575F67" }}>
              <Text fontFamily="amazonEmber" type="b100" color="primary">
                <b>Amazon Meetings Summary</b> is powered by Amazon AI.
                <br />
                <br />
                Always check for accuracy.
              </Text>
            </Theme>
          </Column>
        </Column>
        <ModalFooter>
          <Row alignmentHorizontal="end" widths="fit">
            <Button type="link" size="small" onClick={onClose}>
              Cancel
            </Button>
            <Button type="primary" size="small" minWidth="64px" onClick={handleOK}>
              OK
            </Button>
          </Row>
        </ModalFooter>
      </Modal>
    </Theme>
  );
};

export default InformSummarizeModal;